import React, { lazy, Suspense } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import { Box, Button, Stack } from '@mui/material';
import SelectAvatarSkinItem from '../SelectAvatarSkinItem';
import LoadingProgress from '@components/LoadingProgress';

const Avaturn = lazy(() => import('@features/avaturn/components/Avaturn'));
const Totem = lazy(() => import('@features/readyPlayMe/components/Totem'));

import { IPreviousSelectedAvatarView } from './interfaces';
import { env } from 'env';

import { useStyles } from './styles';

const PreviousSelectedAvatarView = ({
  customAvatarUrl,
  previousSkin,
  onChangeAvatar,
  onSelectAvatar,
  onSelectPrevAvatar,
}: IPreviousSelectedAvatarView) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  let avatar;
  const { REACT_APP_FEATURE_AVATURN, REACT_APP_FEATURE_READY_PLAY_ME } = env;

  const isReadyPlayActive = REACT_APP_FEATURE_READY_PLAY_ME === 'true';
  const isAvaturnActive = REACT_APP_FEATURE_AVATURN === 'true';

  if (previousSkin) {
    avatar = (
      <SelectAvatarSkinItem
        src={previousSkin.previewImage.url}
        alt="skin preview"
        onClick={onSelectAvatar}
      />
    );
  }

  if (!previousSkin && customAvatarUrl) {
    avatar = customAvatarUrl.includes('readyplayer')
      ? isReadyPlayActive && (
          <Suspense fallback={<LoadingProgress />}>
            <Totem onClick={onSelectPrevAvatar} />
          </Suspense>
        )
      : isAvaturnActive && (
          <Suspense fallback={<LoadingProgress />}>
            <Avaturn onClick={onSelectPrevAvatar} />
          </Suspense>
        );
  }

  return (
    <Box sx={classes.root}>
      <Stack sx={classes.prevAvatarButtons}>
        <Button onClick={onChangeAvatar}>{translate('userAvatarPage.changeAvatar')}</Button>
        <Button onClick={onSelectAvatar}>{translate('continue')}</Button>
      </Stack>
      {avatar}
    </Box>
  );
};

export default withTranslation()(PreviousSelectedAvatarView);
